import { render, staticRenderFns } from "./ServiceOrderFooterComponent.vue?vue&type=template&id=5e5c8896&"
import script from "./ServiceOrderFooterComponent.vue?vue&type=script&lang=js&"
export * from "./ServiceOrderFooterComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports